/**
 * RatingRegisterPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Select, Input, Button, Checkbox, Radio } from 'antd';

const RatingRegisterPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '회원 등급명',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="등급명 입력"
                style={{ width: 400 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '회원 등급 설명',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="등급설명 입력"
                style={{ width: 400 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '등급 조건',
      required: true,
      direction: 'column',
      form: [
        {
          input: (
            <>
              <p>구매 금액</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
              />
              <p>원 이상 or</p>
            </>
          ),
        },
        {
          input: (
            <>
              <p>구매 횟수</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
              />
              <p>건 이상</p>
            </>
          ),
        },
      ],
    },
    {
      label: '구매 시 할인/적립 혜택',
      required: true,
      form: [
        {
          input: (
            <Radio.Group value={'혜택없음'}>
              <Radio value={'혜택없음'}>혜택없음</Radio>
              <Radio value={'구매금액 할인'}>구매금액 할인</Radio>
              <Radio value={'적립금 지급'}>적립금 지급</Radio>
              <Radio value={'할인/적립 동시 적용'}>할인/적립 동시 적용</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '구매 금액 할인 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
              />
              <p>원 이상 구매시</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.medium }}
              />
              <Select
                size="large"
                value={'원'}
                options={[
                  { label: '원', value: '원' },
                  { label: '%', value: '%' },
                ]}
                style={{ ...styles.form.input.medium }}
              />
              <p>할인</p>
              <p>(최대</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.medium }}
              />
              <p>원)</p>
            </>
          ),
        },
      ],
    },
    {
      label: '적립금 지급 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
              />
              <p>원 이상 구매시</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.medium }}
              />
              <Select
                size="large"
                value={'원'}
                options={[
                  { label: '원', value: '원' },
                  { label: '%', value: '%' },
                ]}
                style={{ ...styles.form.input.medium }}
              />
              <p>할인</p>
              <p>(최대</p>
              <Input
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.medium }}
              />
              <p>원)</p>
            </>
          ),
        },
      ],
    },
    {
      label: '적립금 자동 지급 여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group value={'사용'}>
              <Radio value={'사용'}>사용</Radio>
              <Radio value={'비사용'}>비사용</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '쿠폰 혜택 적용',
      required: true,
      form: [
        {
          input: <Button size="large">쿠폰조회</Button>,
        },
      ],
    },
    {
      label: '배송비 혜택',
      required: true,
      form: [{ input: <Checkbox size="large">배송비 무료</Checkbox> }],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>회원등급 생성</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <InputFormTable form={form1} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                  color: '#FFFFFF',
                }}
              >
                저장
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                취소
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default RatingRegisterPresenter;
